import apiClient from './client';

export interface Coach {
  id: number;
  name: string;
  email?: string;
  phone?: string;
  coachingMap?: string;
  city?: string;
  state?: string;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CoachFilters {
  page?: number;
  limit?: number;
  search?: string;
  coachingMap?: string;
  city?: string;
  state?: string;
  isActive?: boolean;
}

export interface CreateCoachData {
  name: string;
  email?: string;
  phone?: string;
  coachingMap?: string;
  city?: string;
  state?: string;
  notes?: string;
}

export interface UpdateCoachData {
  name?: string;
  email?: string;
  phone?: string;
  coachingMap?: string;
  city?: string;
  state?: string;
  notes?: string;
  isActive?: boolean;
}

class CoachService {
  async getAllCoaches(filters: CoachFilters = {}) {
    const response = await apiClient.get('/coaches', { params: filters });
    return response.data;
  }

  async getCoach(id: number) {
    const response = await apiClient.get(`/coaches/${id}`);
    return response.data;
  }

  async createCoach(data: CreateCoachData) {
    const response = await apiClient.post('/coaches', data);
    return response.data;
  }

  async updateCoach(id: number, data: UpdateCoachData) {
    const response = await apiClient.put(`/coaches/${id}`, data);
    return response.data;
  }

  async deleteCoach(id: number) {
    const response = await apiClient.delete(`/coaches/${id}`);
    return response.data;
  }

  async getCoachesByMap(coachingMap: string) {
    const response = await apiClient.get(`/coaches/by-map/${coachingMap}`);
    return response.data;
  }

  async getCoachesByLocation(city?: string, state?: string) {
    const response = await apiClient.get('/coaches/by-location', {
      params: { city, state },
    });
    return response.data;
  }
}

export const coachService = new CoachService();

